<!-- 出库单记录 -->
<template>
    <div class="templete_box">
        <div class="templete no_print">
            <div class="search_box clearfix">
                <div class="search_time search_inputBox">
                <el-date-picker v-model="start_time" value-format="timestamp" format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="开始日期"></el-date-picker>
                ~
                <el-date-picker v-model="end_time" value-format="timestamp" format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="结束日期"></el-date-picker>
                </div>
                <el-input class="search_input search_inputBox" v-model="params.search.order_sn" clearable placeholder="销售单号"></el-input>
                <select-down-customer ref="selectdowncustomer" v-if="module.indexOf('warehouse-report-out-order-show-costomer')!=-1" class="searchCustomer" @changeselect="res=>{this.params.search.customer_id = res;}"></select-down-customer>
                <el-select class="search_select search_inputBox search_inputBox_long" v-model="params.search.out_operator_id" clearable placeholder="出库人" @visible-change="getOutList">
                    <el-option v-for="list in outList" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>

                <div class="reset fcolor" @click="reset">重置</div>
                <el-button class="publicBtn" @click="search">查询</el-button>
                <div class="execlInsert">
                    <span class="excel_btn" @click="exportExcelBill"><i class="excel-icon"></i>excel导出</span>
                </div>
            </div>
            <!-- <div class="btnList clearfix">
                <el-button class="publicBtn">打印出库单</el-button>
            </div> -->
            <div class="tableBox">
                <tabletem :isShowIndex="true" :isHideColumn="false" :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" @rowClick="rowClick"></tabletem>
            </div>
            <div class="pagination_path">
                <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="current_page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
            </div>
            <div class="totalCal">
                <div class="totalName">合计：</div>
                <div class="totalNumber">出库立方：{{ statistics.out_cube }}m³</div>
            </div>
        </div>
        <!-- 出库单详情 dialog START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisibleOut" class="eldialog eldialogC threeLabel no_print eldialogWidth" :modal="false" title="出库单" custom-class="full_dialog">
            <div class="dialogSearchBox">
                <el-form class="clearfix dialogFormB dialogForm" :model="form_params" ref="saleorderA">
                    <div class="elFormBox">
                        <el-form-item  label="客户名称：" prop="customer_id" v-if="form_params.customer_name!=''&&module.indexOf('warehouse-report-out-order-show-costomer')!=-1">
                            <!-- <el-select v-model="form_params.customer_id" :disabled="true" filterable>
                                <el-option v-for="list in selectMap.customer" :key="list.id" :value="list.id" :label="list.name"></el-option>
                            </el-select> -->
                            <el-input v-model="form_params.customer_name" disabled></el-input>
                        </el-form-item>
                    </div>
                    <div class="elFormBox">
                        <el-form-item  label="销售人：" prop="salesman_id">
                            <!-- <el-select v-model="form_params.salesman_id" :disabled="true" @visible-change="getSelectList('user')">
                                <el-option v-for="list in selectMap.user" :key="list.id" :value="list.id" :label="list.name"></el-option>
                            </el-select> -->
                            <el-input v-model="form_params.salesman_name" disabled></el-input>
                        </el-form-item>
                    </div>
                    <div class="elFormBox">
                        <el-form-item  label="销售日期：" prop="sales_time">
                            <el-date-picker v-model="form_params.sales_time" type="date" :readonly="true" placeholder="" size="mini"></el-date-picker>
                        </el-form-item>
                    </div>
                    <div class="elFormBox">
                        <el-form-item  label="出库日期：" prop="out_time">
                            <el-date-picker v-model="out_time" type="date" placeholder="" size="mini"></el-date-picker>
                        </el-form-item>
                    </div>
                    <div class="globalFilterBtn" v-if="module.indexOf(',system-column-set,')!=-1" @click="filterDialogVisible=!filterDialogVisible"></div>
                </el-form>
                <div class="dialogFlow">
                    <div class="editBox">
                        <div class="editList">
                            <el-table :data="listDetail" :summary-method="getTableSummaries" ref="outBoundDetailTable" border show-summary stripe highlight-current-row size="mini" height="100%" @header-dragend="headDrog">
                                <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
                                <template v-for="(item) in filters">
                                    <el-table-column :prop="item.field" v-if="item.show && billColumn.includes(item.field)" :key="item.field" :label="item.name"
                                                :sortable="false"
                                                :width="item.width && item.width>0 ?item.width:80+ 'px'"
                                                align="left"
                                                show-overflow-tooltip
                                            >
                                        <template slot-scope="scope">
                                            <div v-if="item.field == 'sales_width_total'">
                                                <span @click="widthList = scope.row.sales_width;dialogVisibleWidth=true;" style="text-decoration:underline;cursor:pointer;">
                                                    {{ scope.row.sales_width_total }}
                                                </span>
                                            </div>
                                            <span v-else>
                                                {{ scope.row[item.field] }}
                                            </span>
                                        </template>
                                    </el-table-column>
                                </template>
                            </el-table>
                            <!-- <el-table :data="listDetail" ref="outBoundDetailTable" border show-summary stripe highlight-current-row size="mini" height="100%">
                                <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
                                <el-table-column label="合同号" width="135" show-overflow-tooltip v-if="billColumn.indexOf(',contract_no,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.contract_no }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="供单号" width="65" show-overflow-tooltip v-if="billColumn.indexOf(',original_bale,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.original_bale }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="货权单位" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',opening_company,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.opening_company }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="捆包号" width="110" show-overflow-tooltip v-if="billColumn.indexOf(',bale_no,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.bale_no }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="出库状态" width="70" show-overflow-tooltip v-if="billColumn.indexOf(',status_text,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.status_text }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="仓库" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',warehouse,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.warehouse }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="库位" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',storage_location,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.storage_location }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="供应商" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',supplier,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.supplier }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="产地" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',place_origin,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.place_origin }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="品牌" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',brand,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.brand }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="品名" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',breed,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.breed }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="等级" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',grade,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.grade }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="厚度" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',sales_thickness,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.sales_thickness }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="长度" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',sales_length,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.sales_length }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="片数" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',pieces,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.pieces }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="层数" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',layer_number,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.layer_number }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="总宽度" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',sales_width_total,')!=-1">
                                    <template slot-scope="scope">
                                        <span @click="widthList = scope.row.sales_width;dialogVisibleWidth=true;" style="text-decoration:underline;cursor:pointer;">
                                            {{ scope.row.sales_width_total }}
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="立方" prop="sales_cube" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',sales_cube,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.sales_cube }}
                                    </template>
                                </el-table-column>
                            </el-table> -->
                        </div>
                    </div>
                    <div class="remarkBox">
                        <textarea class="remarkTextarea" :readonly="true" v-model="form_params.remark" cols="5"></textarea>
                    </div>
                </div>
                <div class="editPersonBox clearfix">
                    <div class="editPerson">制单人：{{form_params.creator_name}}</div>
                    <div class="editPerson">审核人：{{form_params.auditor_name}}</div>
                    <!-- <div class="editPerson">打印时间：{{parseInt(new Date().getTime()/1000) | dateFormat_}}</div> -->
                </div>
                <div class="editBtnList clearfix">
                    <div class="editBtn">
                        <el-button class="funcPublicBtn" @click="print">打印</el-button>
                        <!-- created by xiong -->
                        <el-button class="funcPublicBtn" v-if="module.indexOf(',warehouse-doc-out-export,')!=-1" @click="exportExcel">导出</el-button> 
                    </div>
                </div>
            </div>
        </el-dialog>
        <!-- 出库单详情 dialog END -->
        <filter-fields :tableData="filter" scene="inventory.out.column" :isGlobal="true" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
    </div>
</template>
<style scoped lang="scss">
    .container{
        padding: 15px; display: flex; flex-direction: column; align-items: stretch; text-align: left; height: 100%; background-color: #fff; border-top:8px solid #EEEFF2; border-left:12px solid #EEEFF2;
    }
    .piaoMess{font-size: 12px;color:#777;margin-bottom:10px;}
    .piaoMessC{float: left;width:50%;}
    .order_header{
        font-size:26px; font-weight:bold; line-height:37px; color: #333333; text-align: center; position: relative; top: 15px;
        .code{ left: 50%; position: absolute; margin-left: 154px; font-size: 12px; color: #333333; }
    }
    .bottom_flex{ padding-right: 12px; padding-bottom: 8px; }
    .editPayBox{
        .editPay{width:50%;float: left;height:100px;box-sizing:border-box;padding:10px;}
        .editName{font-size: 12px;color:#777;padding:2px 0;}
        .editPay:nth-child(2n){border-left:1px solid #ccc;}
    }
    .editPersonBox{
        .editPerson{width:33%;float: left;font-size: 12px;color:#777;box-sizing: border-box;padding:5px 0;}
    }
    .editBtnList{padding-top:10px;
        .editTax{float: left;margin-right:20px;}
        .editTaxname{float: left;font-size: 12px;color:#777;line-height: 25px;margin-right:5px;}
        .editTaxinput{float: left;width:100px;}
        .editBtn{float: right;}
    }
</style>
<script>
    import bus from "../../../eventBus";
    import pagination from '../../../components/pagination.vue'
    import tabletem from '../../../components/table.vue'
    import selectDownCustomer from '../../../components/selectDownCustomer.vue'
    export default {
        components:{
            tabletem,
            pagination,
            selectDownCustomer
        },
        data(){
            return{
                tableLoading:false,
                module:localStorage.dw_erp_power_code,
                enableConfig:localStorage.dw_erp_enable_config,
                boardAmericaType:localStorage.dw_erp_board.indexOf("board-america")!=-1?true:false,
                boardAfricaType:localStorage.dw_erp_board.indexOf("board-africa")!=-1?true:false,
                dialogVisibleOut:false,
                filterDialogVisible:false,
                filter:"",
                filters:[],
                form_params:{
                    id:"",
                    account_id:"",
                    first_amount:"",
                    reduce_amoun:"",
                    tax_rate:"",
                    sales_time:"",
                    delivery_time:"",
                    predict_time:"",
                    salesman_id:localStorage.dw_erp_user_id?parseInt(localStorage.dw_erp_user_id):"",
                    customer_id:"",
                    payment_type_id:"",
                    remark:"",
                    is_request_review:"",
                    bank_no:"",
                    account_name:"",
                    out_time:"",
                    bank_name:"",
                    inventory_list:[]
                },
                billColumn:"",
                out_time:new Date(),
                start_time : "",
                end_time : "",
                params:{
                    page : 1,
                    per_page : 50,
                    search : {
                        out_start : "",
                        out_end : "",
                        salesman_id : "",
                        order_sn : "",
                        out_operator_id : ""
                    }
                },

                last_page : 1,
                current_page : 1,
                total:0,
                statistics : {
                    out_cube : 0
                },
                listDetail:[
                    {id:"",inventory_id:"",bale_no:"",supplier:"",brand:"",breed:"",pay_status:"",sales_length:"",sales_width_total:"",sales_cube:"",sales_price:""}
                ],
                bill:{},
                selectMap:{
                    customer:[],
                    user:[],
                    account:[],
                    paymentType:[],
                    lockLevel:[]
                },


                saleManList: [],
                outList : [],
                customerList : [],
                printDetail:{fields:""},
                printTotal:[],
                companyName:localStorage.dw_erp_company_name,
                list:[],
                tableCol:[
                    {colName:"出库日期",colKey:"out_time",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"单据编号",colKey:"order_sn",colWidth:190,isSetWidth:true,isCanClick:true,isShow:true,isColor:true},
                    {colName:"销售人",colKey:"salesman_name",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"客户",colKey:"customer_name",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"件数",colKey:"count",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"销售方数",colKey:"sales_cube",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"方数",colKey:"out_cube",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"制单人",colKey:"creator_name",colWidth:116,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"审核人",colKey:"out_auditor_name",colWidth:116,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"出库人",colKey:"out_operator_name",colWidth:116,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"备注",colKey:"remark",colWidth:155,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                ],
            }
        },
        created() {
            // this.getSelectList("user")
            // this.getSelectList("customer")
            // this.getSelectList("account")
            // this.getSelectList("paymentType")
            // this.getSelectList("lockLevel")
            this.start_time = this.$getCurrentMonthStartValueOf();
            this.end_time = this.$getCurrentMonthEndtValueOf();
            this.search();
            this.tableCol.forEach(item=>{
                if(item.colKey == 'customer_name'){
                    if(this.module.indexOf('warehouse-report-out-order-show-costomer')!=-1){
                        item.isShow = true;
                    }else{
                        item.isShow = false;
                    }
                }
            })
        },
        methods:{
            headDrog(newWidth, oldWidth, column) {
                this.filters.forEach((item) => {
                    if (column.property == item.colKey) {
                        item.colWidth = newWidth;
                    }
                });
                let obj = {};
                obj.width = parseInt(newWidth);
                obj.name = column.property;
                let emit = ("changeHeadWidth" + 'inventory.out.column').replace(/\./g, "");
                bus.$emit(emit, obj);
            },
            filterConfirm(){
                this.getBillColumn()
            },
            getBillColumn(){
                this.filters = [];
                this.postFunc("/erp/company.column.data",{scene:"inventory.out.column"},response=>{
                    this.billColumn = ","+response.data.data.fields.join(",").toString()+",";
                    this.filter = response.data.data.columns;
                    this.filters = response.data.data.columns;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getTableSummaries(params) {
                return this.$setSummaryFields(params, {
                    sales_cube:4,
                    out_cube:4,//出库立方
                },total=>{
                });
            },
            print(){
                let url = "/saleOrderPrint?id=" + this.form_params.id + "&category=" + 1;
                window.open(url);
            },
            exportExcelBill(){
                this.$exportExecl("/erp/export.out.record","出库单记录",this.params)
            },
            getSelectList(target){
                this.$getSelectList(target).then(res=>{
                    this.selectMap[res.target]=res.list;
                })
            },
            getPage(obj){
                this.params.page = obj.currentpage;
                this.params.per_page = obj.pagesize;
            },
            getList(){
                this.tableLoading = true;
                this.postFunc("/erp/report.out.record",this.params,response=>{
                    if(response.data.code == 0){
                        let list = response.data.data.data
                        list.forEach((item) => {
                            item.out_time =  window.moment( Number(item.out_time) * 1000 ).format("YYYY-MM-DD")
                            item.out_cube = Number(item.out_cube).toFixed(4)
                        })
                        this.list = list;
                        this.total = response.data.data.total;
                        this.statistics = response.data.data.statistics;
                        this.last_page = response.data.data.last_page;
                        this.$refs.pagination.flag = true;
                        this.tableLoading = false;
                    }
                },error=>{
                    this.tip(error.data.message,"warning")
                })
                // this.$axios.post("/erp/report.out.record",this.params).then((response) => {
                //     if(response.data.code == 0){
                //         let list = response.data.data.list
                //         list.forEach((item) => {
                //             item.out_time =  window.moment( Number(item.out_time) * 1000 ).format("YYYY-MM-DD")
                //             item.out_cube = Number(item.out_cube).toFixed(4)
                //         })
                //         this.list = list;
                //         this.total = response.data.data.total;
                //         this.statistics = response.data.data.statistics;
                //         this.last_page = response.data.data.last_page;
                //     }
                // }).catch((error) => {
                //     window.console.log(error);
                // })
            },
            search(){
                this.params.search.out_start = parseInt(this.start_time / 1000) == 0 ? "" : parseInt(this.start_time / 1000);
                this.params.search.out_end = parseInt(this.end_time / 1000) == 0 ? "" : parseInt(this.end_time / 1000);
                if(this.params.page == 1){
                    this.getList();
                } else {
                    this.params.page = 1
                }
            },
            reset(){
                this.start_time = this.$getCurrentMonthStartValueOf();
                this.end_time = this.$getCurrentMonthEndtValueOf();
                this.params.search = {
                    out_start : this.$getCurrentMonthStartValueOf(),
                    out_end : this.$getCurrentMonthEndtValueOf(),
                    salesman_id : "",
                    order_sn : "",
                }
                this.$refs['selectdowncustomer'].clearData()
                this.getList()
            },
            rowClick(obj){
                let id = "";
                this.list.forEach(item=>{
                    if(item.id==obj.id){
                        id = item.id;
                    }
                })
                this.getBillColumn();
                this.postFunc("/erp/inventory.out.detail",{id:id},res=>{
                    this.dialogVisibleOut=true;
                    this.form_params=res.data.data;
                    res.data.data.details.forEach(item=>{
                        item.totalPrice=parseFloat(Number(item.sales_cube)*Number(item.sales_price)).toFixed(2)
                    })
                    this.listDetail=JSON.parse(JSON.stringify(res.data.data.details));
                    this.totalObj=res.data.data.statistic;
                    delete this.form_params.details;
                    delete this.form_params.statistic;
                    this.list.forEach(item=>{
                        if(item.id==obj.id){
                            if(item.isOrderOut){
                                this.form_params.isOrderOut=true;
                            }
                        }
                    })
                    this.out_time = res.data.data.out_time == 0 ? new Date() : res.data.data.out_time*1000;
                    this.listDetail.forEach((item,index)=>{
                        this.$nextTick(()=> {
                            this.$refs.outBoundDetailTable.toggleRowSelection(this.listDetail[index],true);
                        })
                    })
                    if(this.form_params.sales_time!=0){
                        this.form_params.sales_time = this.formatTime(this.form_params.sales_time+"000")
                    }
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getBillMess(id){
                this.postFunc("/erp/customer.detail",{id:id},response=>{
                    this.bill=response.data.data;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            selectAccount(val){
                this.selectMap.account.forEach(item=>{
                    if(item.id==val){
                        this.form_params.bank_no=item.bank_no;
                        this.form_params.account_name=item.account_name;
                        this.form_params.bank_name=item.bank_name;
                    }
                })
            },

            // 获取销售员
            getSalemanList(visible){
                if(visible){
                    this.$getSalemanList(this.params.search.customer_id).then(res=>{
                        this.saleManList = res.data.data;
                    })
                }
            },

            // 获取客户
            getCustomerList(visible){
                if(visible){
                    this.$getCustomerList(this.params.search.salesman_id).then(res=>{
                        this.customerList = res.data.data;
                    })
                }
            },

            // 获取出库人
            getOutList(visible){
                if(visible){
                    this.$getSalemanList().then(res=>{
                        this.outList = res.data.data;
                    })
                }
            },

            //导出 created by xiong
            exportExcel(){
                this.$exportExecl("/erp/inventory.out.excel","出库单",{id:this.form_params.id})
            }
        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.search();
            },
            "dialogVisibleOut":function(val){
                if(!val){
                    this.form_params=this.resetJson(this.form_params);
                    this.form_params.inventory_list=[];
                    this.form_params.salesman_id=localStorage.dw_erp_user_id?parseInt(localStorage.dw_erp_user_id):"";
                    this.out_time = new Date();
                    this.listDetail=[{id:"",inventory_id:"",bale_no:"",supplier:"",brand:"",breed:"",pay_status:"",sales_length:"",sales_width_total:"",sales_cube:"",sales_price:""}]
                }
            }
        }
    }
</script>
